import React, { useRef, useEffect, useState, useImperativeHandle, forwardRef } from 'react';

const Turnstile = forwardRef(function Turnstile({ onVerify }, ref) {
  const containerRef = useRef(null);
  const widgetId = useRef(null);
  const callbackRef = useRef(onVerify);
  const [loading, setLoading] = useState(true);

  // Keep callback ref current without triggering re-render
  callbackRef.current = onVerify;

  // Expose reset method to parent via ref
  useImperativeHandle(ref, () => ({
    reset: () => {
      if (widgetId.current !== null && window.turnstile) {
        window.turnstile.reset(widgetId.current);
        callbackRef.current(null); // Clear token in parent
      }
    }
  }), []);

  useEffect(() => {
    const renderWidget = () => {
      if (window.turnstile && containerRef.current && widgetId.current === null) {
        widgetId.current = window.turnstile.render(containerRef.current, {
          sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
          size: 'flexible',
          callback: (token) => {
            setLoading(false);
            callbackRef.current(token);
          },
          'error-callback': () => {
            setLoading(false);
            callbackRef.current(null);
          },
          'expired-callback': () => {
            callbackRef.current(null);
          },
          theme: 'light',
        });
      }
    };

    if (window.turnstile) {
      renderWidget();
    } else {
      const interval = setInterval(() => {
        if (window.turnstile) {
          clearInterval(interval);
          renderWidget();
        }
      }, 100);
      return () => clearInterval(interval);
    }

    return () => {
      if (widgetId.current !== null && window.turnstile) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    };
  }, []);

  return (
    <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
      <div ref={containerRef} style={{ marginBottom: '12px' }} />
      {loading && (
        <p style={{ fontSize: '13px', color: '#888', marginBottom: '12px' }}>
          Loading verification...
        </p>
      )}
    </div>
  );
});

export default Turnstile;
